import TruckPermitRuleForm from './TruckPermitRuleForm';

export default TruckPermitRuleForm;
